import React from 'react'
import { Button, Input, InputCheck } from 'src/components'
import { SavedAnimal } from '../../../components/SavedAnimal'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { CreateAnimalForm } from 'src/@types/validations/Animal'
import { formatDateToInputValue } from 'src/utils'
import { useFormContext } from 'react-hook-form'
import { useStyles } from '../../styles'
import { PregnancyDiagnosisFormParams } from '../..'

interface DiagnosisFormSectionProps {
  savedBirths: CreateAnimalForm[]
  isLoadingAnimal?: boolean
  onOpenDiagnosisModal: () => void
  onRemoveBirth: (index: number) => void
}

export const DiagnosisFormSection: React.FC<DiagnosisFormSectionProps> = ({
  savedBirths,
  isLoadingAnimal = false,
  onOpenDiagnosisModal,
  onRemoveBirth
}) => {
  const style = useStyles()
  const {
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors }
  } = useFormContext<PregnancyDiagnosisFormParams>()

  const diagnostico = watch('diagnostico')
  const dataDiagnostico = watch('dataDiagnostico')
  const tipoReproducao = watch('tipoReproducao')

  const today = new Date().toISOString().split('T')[0]

  const validateDateNotFuture = (value: string, fieldName: string, fieldLabel: string) => {
    const selectedDate = new Date(value)
    const todayDate = new Date(today)

    if (selectedDate > todayDate) {
      setError(fieldName as any, { message: `${fieldLabel} não pode ser superior à data de hoje` })
      return false
    }
    return true
  }

  return (
    <section className={`${style.section} ${style.diagnosisSection}`}>
      <div className={style.diagnosisInfoContainer}>
        <div className={style.formControl}>
          <Input
            type='date'
            max={today}
            label='Data do Diagnóstico'
            value={formatDateToInputValue(dataDiagnostico)}
            error={errors?.dataDiagnostico?.message}
            disabled={isLoadingAnimal}
            onChange={(value: string) => {
              if (validateDateNotFuture(value, 'dataDiagnostico', 'Data do Diagnóstico')) {
                setValue('dataDiagnostico', value)
                clearErrors('dataDiagnostico')
              } else {
                setValue('dataDiagnostico', value)
              }
            }}
          />
        </div>

        <div>
          <div className={style.radioGroupInline}>
            <InputCheck
              id='diagnostico-prenha'
              type='radio'
              name='diagnosis_status'
              value='prenha'
              label='Prenha'
              checked={diagnostico === 'prenha'}
              onChange={() => setValue('diagnostico', 'prenha', { shouldDirty: true })}
              error={errors?.diagnostico?.message}
            />
            <InputCheck
              id='diagnostico-vazia'
              type='radio'
              name='diagnosis_status'
              value='vazia'
              label='Vazia'
              checked={diagnostico === 'vazia'}
              onChange={() => setValue('diagnostico', 'vazia', { shouldDirty: true })}
              className={errors?.diagnostico?.message ? 'input-check--error' : ''}
            />
          </div>
        </div>

        {diagnostico === 'prenha' && (
          <>
            <div className={style.sectionHeader}>
              <h3 className={style.sectionTitle}>Crias</h3>
              {tipoReproducao && savedBirths.length > 0 && (
                <Button
                  type='button'
                  className={`${style.buttonWrapper} ${style.buttonOutlined}`}
                  onClick={onOpenDiagnosisModal}
                  disabled={isLoadingAnimal}
                  outlined
                >
                  Adicionar Cria
                </Button>
              )}
            </div>

            {savedBirths.length === 0 ? (
              <div className={style.pendingDiagnosisContainer}>
                {/* <div className={style.pendingDiagnosisContent}>
                  <InfoOutlinedIcon className={style.pendingDiagnosisIcon} />
                  <span className={style.pendingDiagnosisText}>
                    Gestação em andamento - adicione as crias quando nascerem
                  </span>
                </div> */}
                {tipoReproducao && (
                  <Button
                    type='button'
                    className={style.buttonWrapper}
                    onClick={onOpenDiagnosisModal}
                    disabled={isLoadingAnimal}
                  >
                    Adicionar Cria
                  </Button>
                )}
              </div>
            ) : (
              <div className={style.diagnosisInfoContainer}>
                {savedBirths.map((birth, index) => (
                  <SavedAnimal
                    key={`birth-${index}`}
                    savedBirthAnimal={birth}
                    index={index}
                    onRemove={() => onRemoveBirth(index)}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  )
}
